// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useData } from "../context/DataContext";
// import { useAuth } from "../context/AuthContext";
// import { ordersAPI } from "../api";

// export default function OrderDetailScreen() {
//     const { orderId } = useParams(); // получаем номер заказа из URL (например, /order/123)
//     const navigate = useNavigate();
//     const { user } = useAuth();
//     const { fetchOrderByNotification } = useData();

//     const [order, setOrder] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [taking, setTaking] = useState(false);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         loadOrder();
//     }, [orderId]);

//     const loadOrder = async () => {
//         try {
//             setLoading(true);
//             // fetchOrderByNotification возвращает уже обработанный объект заказа (как в мобильном)
//             const orderData = await fetchOrderByNotification(orderId);
//             if (orderData) {
//                 setOrder(orderData);
//                 // Отмечаем заказ просмотренным (как в мобильном приложении)
//                 if (user?.uid_master) {
//                     ordersAPI.viewOrder(orderData.orderNumber, user.uid_master).catch((err) => console.log(err));
//                 }
//             } else {
//                 setError("Заказ не найден или уже недоступен");
//             }
//         } catch (err) {
//             console.error("Ошибка загрузки заказа:", err);
//             setError("Не удалось загрузить заказ");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleTakeOrder = async () => {
//         if (!user?.uid_master || !order) return;
//         setTaking(true);
//         try {
//             // В мобильном приложении используется takeOrderWithUser
//             await ordersAPI.takeOrderWithUser(order.orderNumber, user.uid_master);
//             alert("Вы взяли заказ");
//             navigate(-1); // возвращаемся назад
//         } catch (error) {
//             console.error(error);
//             alert("Не удалось взять заказ");
//         } finally {
//             setTaking(false);
//         }
//     };

//     // Загрузка
//     if (loading) {
//         return (
//             <div className="flex h-screen items-center justify-center bg-white">
//                 <div className="text-center text-gray-500">Загрузка заказа...</div>
//             </div>
//         );
//     }

//     // Ошибка
//     if (error) {
//         return (
//             <div className="px-4 pt-4">
//                 <div className="bg-red-50 p-4 rounded-xl text-red-600">{error}</div>
//                 <button onClick={() => navigate(-1)} className="mt-4 bg-gray-200 py-2 px-4 rounded-full">
//                     Назад
//                 </button>
//             </div>
//         );
//     }

//     // Заказ не получен
//     if (!order) {
//         return (
//             <div className="px-4 pt-4">
//                 <div className="text-gray-500">Заказ не найден</div>
//                 <button onClick={() => navigate(-1)} className="mt-4 bg-gray-200 py-2 px-4 rounded-full">
//                     Назад
//                 </button>
//             </div>
//         );
//     }

//     // Основной контент
//     return (
//         <div className="px-4 pt-4 pb-20">
//             <button onClick={() => navigate(-1)} className="mb-4 text-blue-500">
//                 ← Назад
//             </button>

//             <h2 className="text-2xl font-bold text-gray-800 mb-1">№ {order.orderNumber}</h2>
//             <div className="bg-white p-4 rounded-xl shadow-sm space-y-2 text-gray-700">
//                 <p>{order.city}</p>
//                 <p>
//                     {order.title} {order.brand}
//                 </p>
//                 <p>Возраст (лет): {order.age}</p>
//                 <p>Представиться: {order.partner}</p>
//                 <p>Описание: {order.description}</p>
//                 <p>Озвучены цены: {order.priceText}</p>
//                 <p>Комиссионные: {order.commission}</p>
//                 <p>
//                     Быть: {order.appointmentDate} время: {order.appointmentTime}
//                 </p>
//                 <p>Клиент: {order.clientName}</p>
//                 <p>Дата заявки: {order.requestDate}</p>
//                 <p>Доп. инфо: {order.additionalInfo || "—"}</p>
//             </div>

//             <button onClick={handleTakeOrder} disabled={taking} className="w-full bg-blue-500 py-4 rounded-full mt-6 text-white font-medium text-lg disabled:opacity-50">
//                 {taking ? "Загрузка..." : "Взять заказ"}
//             </button>
//         </div>
//     );
// }

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useData } from "../context/DataContext";
import { useAuth } from "../context/AuthContext";
import { ordersAPI } from "../api";

export default function OrderDetailScreen() {
    const { orderId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const { fetchOrderByNotification } = useData();

    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [taking, setTaking] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadOrder();
    }, [orderId]);

    const loadOrder = async () => {
        try {
            setLoading(true);
            const orderData = await fetchOrderByNotification(orderId);
            if (orderData) {
                setOrder(orderData);
                // Отмечаем заказ просмотренным (как в мобильном приложении)
                if (user?.uid_master) {
                    ordersAPI.viewOrder(orderData.orderNumber, user.uid_master).catch((err) => console.log(err));
                }
            } else {
                setError("Заказ не найден или уже недоступен");
            }
        } catch (err) {
            console.error("Ошибка загрузки заказа:", err);
            setError("Не удалось загрузить заказ");
        } finally {
            setLoading(false);
        }
    };

    const handleTakeOrder = async () => {
        if (!user?.uid_master || !order) return;
        setTaking(true);
        try {
            await ordersAPI.takeOrderWithUser(order.orderNumber, user.uid_master);
            alert("Вы взяли заказ");
            // После взятия возвращаемся на основной экран
            navigate("/orders");
        } catch (error) {
            console.error(error);
            alert("Не удалось взять заказ");
        } finally {
            setTaking(false);
        }
    };

    // Безопасная функция "Назад"
    const handleBack = () => {
        // Если есть история – идём назад, иначе переходим на список заказов
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/orders");
        }
    };

    // Загрузка
    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center bg-white">
                <div className="text-center text-gray-500">Загрузка заказа...</div>
            </div>
        );
    }

    // Ошибка
    if (error) {
        return (
            <div className="px-4 pt-4">
                <div className="bg-red-50 p-4 rounded-xl text-red-600">{error}</div>
                <button onClick={handleBack} className="mt-4 bg-gray-200 py-2 px-4 rounded-full">
                    Назад
                </button>
            </div>
        );
    }

    // Заказ не получен
    if (!order) {
        return (
            <div className="px-4 pt-4">
                <div className="text-gray-500">Заказ не найден</div>
                <button onClick={handleBack} className="mt-4 bg-gray-200 py-2 px-4 rounded-full">
                    Назад
                </button>
            </div>
        );
    }

    // Основной контент
    return (
        <div className="px-4 pt-4 pb-20">
            <button onClick={handleBack} className="mb-4 text-blue-500">
                ← Назад
            </button>

            <h2 className="text-2xl font-bold text-gray-800 mb-1">№ {order.orderNumber}</h2>
            <div className="bg-white p-4 rounded-xl shadow-sm space-y-2 text-gray-700">
                <p>{order.city}</p>
                <p>
                    {order.title} {order.brand}
                </p>
                <p>Возраст (лет): {order.age}</p>
                <p>Представиться: {order.partner}</p>
                <p>Описание: {order.description}</p>
                <p>Озвучены цены: {order.priceText}</p>
                <p>Комиссионные: {order.commission}</p>
                <p>
                    Быть: {order.appointmentDate} время: {order.appointmentTime}
                </p>
                <p>Клиент: {order.clientName}</p>
                <p>Дата заявки: {order.requestDate}</p>
                <p>Доп. инфо: {order.additionalInfo || "—"}</p>
            </div>

            <button onClick={handleTakeOrder} disabled={taking} className="w-full bg-blue-500 py-4 rounded-full mt-6 text-white font-medium text-lg disabled:opacity-50">
                {taking ? "Загрузка..." : "Взять заказ"}
            </button>
        </div>
    );
}
